export type GetDataParams = {
  projectId: string
}

const endpoints = {
  // Конкуренты
  getCompetitors: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/competitors/`
  },
  // Уникальные ресурсы бизнеса
  getResources: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/resources/`
  },
  // Маркетинговый план
  getMarketingPlan: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/marketing_plan/`
  },
  // Путь Клиента CJM (Customer Journey Map)
  getCjm: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/cjm/`
  },
  // Офферы (Предложения)
  getOffers: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/offers/`
  },
  // Боли Мотивы и Выгоды
  getPmb: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/pmb/`
  },
  // Ранжирование Болей
  getPainsRating: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/pains_rating/`
  },
  // Ранжирование Выгод
  getBenefitsRating: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/benefits_rating/`
  },
  // Ранжирование Мотивов
  getMotivesRating: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/motives_rating/`
  },
  // Сегментация (Целевая аудитория)
  getSegmentation: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/segmentation/`
  },
  // Сегментация (рейтинг)
  getSegmentationRating: ({ projectId }: GetDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/data/segmentation_rating/`
  },
}

export default endpoints
